<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{TitleLevel}}</h6>
            <div class="text-center">
                <h4 class="fix-margin">
                    {{MarketingLevel}}
                </h4>
            </div>
            <div class="line-divider mt-4 mb-3"></div>
            <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-6 border-right">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{TitleSubsets}}
                    </div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{SubsetsNumber}}
                        </h4>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{TitleClicks}}
                    </div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{ClicksNumber}}
                        </h4>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "",

        props: {
            TitleLevel: {
                default() {
                    return {}
                }
            },
            TitleClicks: {
                default() {
                    return {}
                }
            },
            TitleSubsets: {
                default() {
                    return {}
                }
            },
            ClicksNumber: {
                default() {
                    return {}
                }
            },
            MarketingLevel: {
                default() {
                    return {}
                }
            },
            SubsetsNumber: {
                default() {
                    return {}
                }
            },
        },

    }
</script>

<style>

</style>